import { getCreditCardApi } from 'billing/modules/CreditCardModule/CreditCardModule.api';
import { Card } from 'billing/modules/CreditCardModule/CreditCardModule.types';
import { CommonModule } from 'utils/CommonModule';
import { ModuleHelper } from 'utils/moduleHelper';

import { BoundCurrentUserSelectors } from 'reactApp/modules/CurrentUserModule';

const getModule = ModuleHelper.wrapMultimodule(
    (pid: string = BoundCurrentUserSelectors.getPid()) => {
        const apiMethods = getCreditCardApi(pid);
        const {
            Actions: { initialLoadData: loadData },
            Selectors: { getData },
        } = CommonModule.createCommonModule<Card | undefined>({
            apiMethods,
            entityName: 'creditCard',
            entityNamePublic: 'карты',
            key: { pid },
        });

        const Actions = {
            loadData,
            removeCard: (bindId: string) => () => apiMethods.removeCard(bindId),
        };

        const Selectors = {
            getData,
        };

        return { Actions, Selectors };
    },
);

export const getCreditCardActions = (pid?: string) => getModule(pid).Actions;
export const getCreditCardSelectors = (pid?: string) =>
    getModule(pid).Selectors;
